/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VendorErrorCodeAssetTypeSummaryDto
 */
export interface VendorErrorCodeAssetTypeSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeAssetTypeSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeAssetTypeSummaryDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeAssetTypeSummaryDto
     */
    code: string;
}

/**
 * Check if a given object implements the VendorErrorCodeAssetTypeSummaryDto interface.
 */
export function instanceOfVendorErrorCodeAssetTypeSummaryDto(value: object): value is VendorErrorCodeAssetTypeSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function VendorErrorCodeAssetTypeSummaryDtoFromJSON(json: any): VendorErrorCodeAssetTypeSummaryDto {
    return VendorErrorCodeAssetTypeSummaryDtoFromJSONTyped(json, false);
}

export function VendorErrorCodeAssetTypeSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorCodeAssetTypeSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
    };
}

export function VendorErrorCodeAssetTypeSummaryDtoToJSON(json: any): VendorErrorCodeAssetTypeSummaryDto {
    return VendorErrorCodeAssetTypeSummaryDtoToJSONTyped(json, false);
}

export function VendorErrorCodeAssetTypeSummaryDtoToJSONTyped(value?: VendorErrorCodeAssetTypeSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
    };
}

